import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { upgradeDocumentStorage } from "Routes/paths";

const StorageExhaustedPopup = ({ showPopup, handleClose }) => {

  return (
    <>
      <Modal
        show={showPopup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="FormPop"
      >
        <Modal.Header closeButton>
          <Modal.Title>⚠️ Storage Exhausted</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" className="">
              <p className="m-0">You've used up all your available storage. To continue uploading new documents, you'll need to free up space or <Link to={upgradeDocumentStorage}>buy more storage</Link>.</p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="FormbtnWrpper justify-content-end d-flex gap-10">
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StorageExhaustedPopup;
